<template>
    <div>
        <v-row>
            <v-col class="col-3 offset-2">
                <p class="text-h6">
                    Código de cliente: <span class="orange--text text--darken-4">{{ clientCode }}</span>
                </p>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="col-12">
                <v-card

                >
                    <v-card-title>Importação de arquivo de integração</v-card-title>


                    <v-card-text>
                        <v-row>
                            <v-col
                                cols="6"
                                md="4"
                            >
                                <v-alert v-if="uploadMessage" border="left">
                                    {{ uploadMessage }}
                                </v-alert>

                                <v-progress-linear
                                    v-show="uploadProgress > 0"
                                    v-model="uploadProgress"
                                    color="light-blue"
                                    height="25"
                                    reactive
                                >
                                    <strong>{{ uploadProgress }} %</strong>
                                </v-progress-linear>

                                <v-form ref="form">
                                    <v-file-input
                                        label="Arquivo de integração"
                                        dense
                                        accept="txt/*"
                                        counter
                                        show-size
                                        truncate-length="50"
                                        @change="selectFile"
                                        v-model="inputFile"
                                    >
                                        <template v-slot:selection="{ text }">
                                            <v-chip
                                                small
                                                label
                                                color="primary"
                                            >
                                                {{ text }}
                                            </v-chip>
                                        </template>
                                    </v-file-input>
                                </v-form>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions>
                        <v-btn color="blue darken-1" text
                               @click="doUpload"
                               class="ma-2"
                               :loading="loading"
                        >
                            Processar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    data: () => ({
        endpoint: 'integracao',
        inputFile: null,
        uploadProgress: 0,
        uploadMessage: "",

        // btn loading
        loader: null,
        loading: false,

        clientCode: '',
    }),

    created() {
        this.showClientCode();
    },

    methods: {
        showClientCode() {
            let user = JSON.parse(localStorage.getItem('user'));

            if (user && user.client_code) {
                this.clientCode = user.client_code;
            }
        },

        selectFile(file) {
            this.uploadProgress = 0;

            if (!(this.inputFile.type == "text/csv" || this.inputFile.type == "text/plain")) {
                this.inputFile = undefined
                alert("Erro, formato inválido, permitido apenas texto/csv")
            }
        },

        doUpload: function () {
            this.uploadMessage = "";

            if (!this.inputFile) {
                return false;
            }

            let formData = new FormData();

            formData.append("file", this.inputFile);
            this.$store.getters.getUsrEndpoint;
            let user = JSON.parse(localStorage.getItem('user'));

            if (user && user.id) {

            }else{
                return false;
            }

            axios.post('/integracoes/arquivos?usuario_id=' + user.id, formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                },
                onUploadProgress: function (progressEvent) {
                    this.uploadProgress = parseInt(
                        Math.round((progressEvent.loaded / progressEvent.total) * 100)
                    );
                }.bind(this)
            }).then((response) => {
                this.uploadMessage = response.data.message;
                this.inputFile = null;
                this.getFromApi();
                // return UploadService.getFiles();
            }).then((files) => {
                this.fileInfos = files.data;
            }).catch((e) => {
                this.uploadProgress = 0;
                this.uploadMessage = e.response.data.msg;
                // this.currentFile = undefined;
            });
            // this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        },
    },
}
</script>
